import { html } from 'lit';
import { createElement, Minus } from 'lucide';
import { pdsCustomIconElement as customElement } from '../../../decorators/pds-icon';
import { PdsIcon } from '../PdsIcon';

@customElement('pds-icon-minus')
export class PdsIconMinus extends PdsIcon {
  createIconElement(): SVGElement {
    return createElement(Minus);
  }

  render() {
    return html`${this.icon}`;
  }
}
